export default __webpack_public_path__ + "static/twitter_card-160d4ddad6a43c6ca70aee217227d966.jpg";